import type { SVGProps } from 'react';

import type { StepId, StepperInputs, StepperType } from '../common';
import SiteTemplateSVG from './SiteTemplateSVG';
import { useSiteTemplateState } from './useSiteTemplateState';

type SiteTemplateProps<T extends StepperType> = SVGProps<SVGSVGElement> & {
    stepperType: T;
    inputs: StepperInputs<T>;
    step: StepId<T>;
};

export function SiteTemplate(props: SiteTemplateProps<StepperType>) {
    const { stepperType, inputs, step, ...svgProps } = props;

    useSiteTemplateState({
        step,
        name: inputs.name ?? 'Untitled',
        currentPlan: 'features' in inputs ? inputs.features.plan : null,
        noContent: inputs.content === 'empty',
        publishLater: inputs.publish === 'later',
        withVA: 'withVA' in inputs ? Boolean(inputs.withVA) : true,
    });

    return <SiteTemplateSVG {...svgProps} />;
}
